import React from 'react'
import PropTypes from 'prop-types'

import { Description } from './Description'
import CTAButton from '../CTAButton/CTAButton'
import { ContentContainer, ContentWrapper, Header, Headline } from './styles'

export default function CopyBlock({
  heading,
  useBullets,
  descriptionList,
  description,
  useCTA,
  ctaText,
  ctaLink,
  ctaVariant,
  ctaAnalytics,
  textLeft,
}) {
  return (
    <ContentContainer>
      <ContentWrapper textLeft={textLeft}>
        <Header>
          <Headline textLeft={textLeft}>{heading}</Headline>
          <Description
            textLeft={textLeft}
            useBullets={useBullets}
            descriptionList={descriptionList}
            description={description}
          />
        </Header>
        {useCTA && (
          <CTAButton ctaLink={ctaLink} ctaVariant={ctaVariant} ctaAnalytics={ctaAnalytics}>
            {ctaText}
          </CTAButton>
        )}
      </ContentWrapper>
    </ContentContainer>
  )
}

CopyBlock.propTypes = {
  heading: PropTypes.string.isRequired,
  useBullets: PropTypes.bool.isRequired,
  descriptionList: PropTypes.array.isRequired,
  description: PropTypes.string.isRequired,
  useCTA: PropTypes.bool.isRequired,
  ctaText: PropTypes.string,
  ctaLink: PropTypes.string,
  ctaVariant: PropTypes.bool,
  ctaAnalytics: PropTypes.string,
  textLeft: PropTypes.bool,
}
